import { createContext, ReactNode, RefObject, useContext, useRef } from 'react';
import { Toast } from 'primereact/toast';
import { useFullscreenDialogParent } from '../general/use-fullscreen-dialog-parent';

const AppToastContext = createContext<RefObject<Toast | null> | null>(null);

/** Notifications survive editor mode changes and client-side navigation. */
export function AppToastProvider({ children }: { children: ReactNode }) {
    const toastRef = useRef<Toast>(null);
    return <AppToastContext.Provider value={toastRef}>
        <ToastHost toastRef={toastRef} />
        {children}
    </AppToastContext.Provider>;
}

export function useAppToastRef() {
    const shared = useContext(AppToastContext);
    const local = useRef<Toast>(null);
    return shared ?? local;
}

/** Keeps standalone editors usable without creating duplicate hosts in the app. */
export function AppToastOutlet({ toastRef }: { toastRef: RefObject<Toast | null> }) {
    const shared = useContext(AppToastContext);
    return shared ? null : <ToastHost toastRef={toastRef} />;
}

function ToastHost({ toastRef }: { toastRef: RefObject<Toast | null> }) {
    const parent = useFullscreenDialogParent();
    return <Toast ref={toastRef} position="top-right" appendTo={parent ?? document.body} baseZIndex={12000} />;
}
